import React, { Component } from 'react';
import Backdrop from '../Backdrop/Backdrop';
import classes from './Modal.module.css'

import logo from '../../../assets/images/logo-aktion-saubere-haende.png';
import closeIcon from '../../../assets/images/cancel.svg';
import htmlContent from '../../../howto.html';
class Modal extends Component {
    state = {}

    render() {
        const closeStyle = {
            backgroundImage: `url(${closeIcon})`
        }
        return (
            <>
                <Backdrop click={this.props.click} />
                <div className={classes.Modal}>
                    <div className={classes.CloseBtn} onClick={this.props.click} style={closeStyle}></div>
                    <img src={logo} className={classes.Logo} alt="Aktion Saubere Hände" />
                    <h2 className={classes.Headline}>Wie funktioniert das Lernmodul?</h2>
                    <div className={classes.Content}>
                        <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
                    </div>
                </div>
            </>);
    }
}

export default Modal;